import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { RootState } from '../redux/store';
import { Center, Spinner } from '@chakra-ui/react';

const AdminRoute = ({ children }) => {
	const { isAuthenticated, isAdmin, loading } = useSelector(
		(state: RootState) => ({
			isAuthenticated: state.auth.isAuthenticated,
			isAdmin: state.auth.isAdmin,
			loading: state.auth.loading,
		})
	);
	const location = useLocation();

	if (loading) {
		// Show a loading spinner while authentication status is being determined
		return (
			<Center h="100vh">
				<Spinner size="xl" />
			</Center>
		);
	}

	if (!isAuthenticated) {
		// User is not logged in, redirect to login page
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	if (!isAdmin) {
		// User is logged in but is not an admin, redirect to an unauthorized page
		return <Navigate to="/unauthorize" replace />;
	}

	// If authenticated and is an admin, render the component
	return children;
};

export default AdminRoute;
